// Client mirror of functions-common/src/charts/datasets/focus.ts. Keep in sync.

import type { DatasetDefinition } from '../types.js'

export const focusDataset: DatasetDefinition = {
  key: 'focus',
  labelKey: 'NLSChartDatasetFocus',
  fields: [
    { name: 'person', labelKey: 'NLSChartFieldPerson', kind: 'dimension', type: 'string' },
    { name: 'minutes', labelKey: 'NLSChartFieldMinutes', kind: 'measure', type: 'number' },
    { name: 'sessions', labelKey: 'NLSChartFieldSessions', kind: 'measure', type: 'number' },
    { name: 'day', labelKey: 'NLSChartFieldDay', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'minutes', agg: 'sum' },
  defaultTimeField: 'day',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER'],
  available: false,
  unavailableReason: 'Focus sessions are not persisted to database',
}
